angular.module('unergie.main')
.controller('ogcCampaignModalCtrl', ($scope, $uibModalInstance, DataModelService,
    OGC, AlertManager, ErrorCatcher, campaign) => {
    $scope.campaign = campaign || {}

    $scope.campaignTypes = [
        { id: 'GEST', label: 'Gestion' },
        { id: 'CDVC', label: 'Cycle de vie client' },
        { id: 'RELC', label: 'Relationnel client' },
        { id: 'CDVP', label: 'Cycle de vie prospect' },
        { id: 'RELP', label: 'Relationnel prospect' },
    ]

    $scope.mandatoryField = (field) => {
        return {
            'fa-check green': field,
            'fa-times red': !field,
        }
    }

    $scope.optionalField = (field) => {
        return {
            'fa-check green': field,
            'fa-check grey': !field,
        }
    }

    $scope.updateName = () => {
        if (!$scope.campaign.name) {
            $scope.campaign.name = `${$scope.campaign.type}_`
        } else if ($scope.campaign.name.includes('_')) {
            const nameArray = $scope.campaign.name.split('_')
            nameArray.shift()
            const withoutPrefix = nameArray.join('_')
            $scope.campaign.name = `${$scope.campaign.type}_${withoutPrefix}`
        } else {
            $scope.campaign.name = `${$scope.campaign.type}_${$scope.campaign.name}`
        }
    }

    $scope.refresh = () => {
        $scope.fetchingContents = true
        return OGC.fetchExternalCampaigns().$promise.then((externalCampaigns) => {
            $scope.externalCampaigns = externalCampaigns
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.fetchingContents = false
        })
    }

    $scope.canSave = () => {
        return !!$scope.campaign.name
    }

    $scope.save = () => {
        $scope.saving = true
        if ($scope.campaign.id) {
            return OGC.updateCampaign({ id: $scope.campaign.id }, _.omit($scope.campaign, 'id')).$promise.then(() => {
                AlertManager.success(`Campagne mise à jour`)
                $scope.close()
            })
            .catch(ErrorCatcher)
            .finally(() => {
                $scope.saving = false
            })
        }
        return OGC.addCampaign($scope.campaign).$promise.then(() => {
            AlertManager.success(`Campagne créée`)
            $scope.close()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.saving = false
        })
    }

    // RETURN OK
    $scope.close = () => $uibModalInstance.close()

    const activate = () => {
        $scope.refresh()
    }

    activate()
})
